import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';

export default function BottomBar(){
    
    return(
        <AppBar position="static" 
        color="dark" sx={{ top: 'auto', bottom: 0 }}>
        <Toolbar sx={{alignItems:"center",
        justifyContent:"center"}}>
            <Typography color="primary">
                Copyright ©2025 All rights reserved
            </Typography>
        </Toolbar>
      </AppBar>
    )
}